import React, { useState } from 'react';
import './SignIn.css';
import Copyright from '../components/Copyright';
import CurrentTime from '../components/CurrentTime';
import DynamicIsland from '../components/DynamicIsland';

function SignIn({ school }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [emailError, setEmailError] = useState('');
  const [passwordError, setPasswordError] = useState('');
  const [loginError, setLoginError] = useState('');

  const allowedEmail = 'student@towson.edu';
  const allowedPassword = 'securePassword';

  // Handler for login
  const handleLogin = () => {
    setEmailError('');
    setPasswordError('');
    setLoginError('');
    let isValid = true;

    if (!email.trim()) {
      setEmailError('Please enter your email.');
      isValid = false;
    }
    if (!password.trim()) {
      setPasswordError('Please enter your password.');
      isValid = false;
    }

    if (isValid) {
      if (email === allowedEmail && password === allowedPassword) {
        window.location.href = '/loading'; // Navigate to the loading page
      } else {
        setLoginError('Invalid email or password. Please try again.');
      }
    }
  };

  return (
    <section className={`sign-in-container ${school.replace(/\s+/g, '-').toLowerCase()}`} >
      <CurrentTime />
      <DynamicIsland />
      <h1 className="welcome-text">Welcome back 👋</h1>
      <div className="university-logo-placeholder"
      >
        <img className="sign-in-towson-logo" src="./img/towson-logo.jpg" alt="Towson University logo" aria-label="TU Logo"
        style={{
          position: "relative",
          alignItems: "center",
          margin: "auto 0",
          justifyContent: "center",
        }}
        />
      </div>

      <div className="input-container">
        <label htmlFor="email" className="input-label">Email</label>
        <input
          type="email"
          id="email"
          className="input-field"
          placeholder="Enter email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <div className="error-message">{emailError}</div>
      </div>

      <div className="password-container">
        <label htmlFor="password" className="input-label">Password</label>
        <div className="password-field-container">
          <input
            type="password"
            id="password"
            className="input-field"
            placeholder="Enter password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        <div className="error-message">{passwordError}</div>
      </div>

      <div className="options-container">
        <div className="remember-me-container">
          <label htmlFor="remember-me" className="checkbox-label">
            <input type="checkbox" className="checkbox" id="remember-me" />
            <span>Remember Me</span>
          </label>
        </div>
      </div>

      <div className="error-message">{loginError}</div>
      <button onClick={handleLogin} className="sign-in-button">Sign In</button>

      <Copyright />
    </section>
  );
}

export default SignIn;
